// extracted by mini-css-extract-plugin
module.exports = {"uploadedImage":"styles_uploadedImage__2430A","image":"styles_image__25IFI","description":"styles_description__1qfLQ","remove":"styles_remove__1WhMo"};